import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconQuickAi: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="quick-ai, rising"><path d="M16.1542 2.75H15.0219L13.6064 6.43015L9.92627 7.84559V8.97794L13.6064 10.3934L15.0219 14.0735H16.1542L17.5697 10.3934L21.2498 8.97794V7.84559L17.5697 6.43015L16.1542 2.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M3.75 20.2498L10.9559 13.0439" stroke="currentColor" strokeWidth="1.5"/><path d="M8.89697 20.2499L12.4999 16.647" stroke="currentColor" strokeWidth="1.5"/><path d="M3.75 15.1029L7.35294 11.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconQuickAi;
